import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

import { ApiResponse } from "@core/types";

interface ApiOptions {
  params?: HttpParams | Record<string, string | number | boolean | readonly (string | number | boolean)[]>;
  headers?: HttpHeaders | Record<string, string>;
}

@Injectable({ providedIn: "root" })
export class ApiService {
  private readonly http = inject(HttpClient);

  get<T>(url: string, options?: ApiOptions): Observable<ApiResponse<T>> {
    return this.http.get<ApiResponse<T>>(url, options);
  }

  post<T>(url: string, body: unknown, options?: ApiOptions): Observable<ApiResponse<T>> {
    return this.http.post<ApiResponse<T>>(url, body, options);
  }

  put<T>(url: string, body: unknown, options?: ApiOptions): Observable<ApiResponse<T>> {
    return this.http.put<ApiResponse<T>>(url, body, options);
  }

  delete<T>(url: string, options?: ApiOptions): Observable<ApiResponse<T>> {
    return this.http.delete<ApiResponse<T>>(url, options);
  }
}
